import { reaction } from 'mobx';
import { addDisposer } from 'mobx-state-tree';

import { configureLogger } from '../../utils/logError';
import type { IStore } from '../Store';

const configureTrackJsOnUserChange = (store: IStore) => {
  // If the user changes we want to update the trackJs logger
  const onUserChange = reaction(
    () => store.userStore.user,
    (user) => {
      if (user) {
        configureLogger(store);
      }
    },
  );

  addDisposer(store, onUserChange);
};

export default configureTrackJsOnUserChange;
